import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./SingleCart.css";
import configData from "../config.json";

import {
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Button,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
//search-select-virtualized
import Select, { createFilter } from "react-select";
import { FixedSizeList as List } from "react-window";
import ResponsiveAppBar from "../components/realtime_components/ResponsiveAppBar";
//toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReconnectingEventSource from "reconnecting-eventsource";
import GetConfig from "../components/multi_components/GetConfig";
import QrList from "../components/multi_components/QrList";
import ScreenShot from "../components/multi_components/ScreenShot";
import Searched from "../components/multi_components/Searched";
import ShoppingList from "../components/multi_components/ShoppingList";
import { getToken } from "../utils/auth"

const CustomMenuList = (props) => {
  const itemHeight = 35;
  const { options, children, maxHeight, getValue } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * itemHeight;

  return (
    <div>
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={itemHeight}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    </div>
  );
};

function SingleCart() {
  //states
  const params = useParams();
  const navigate = useNavigate();
  const [cartData, setCartData] = useState(null);
  const [campaigns, setCampaigns] = useState(null);
  const [microMoment, setMicroMoment] = useState(null);
  const [shopingList, setShopingList] = useState([]);
  const [termsSearched, setTermsSearched] = useState([]);
  const [products, setProducts] = useState([]);
  const [qrTextInputs, setQrTextInputs] = useState(null);
  const customFilter = createFilter({
    ignoreAccents: true,
    ignoreCase: true,
    trim: true,
  });

  //table of information
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/carts_last_events/${params.serial_number}/${params.store}/${params.retailer}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setCartData(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);
  //microMoment active
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Micromoments/${params.retailer}/${params.store}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setMicroMoment(data);
      })

      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);
  //campaigns
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Campaigns/${params.retailer}/${params.store}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setCampaigns(data);
      })

      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);
  //products active
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(
      `${configData.SERVER_URL}/Products/${params.retailer}/${params.store}`,
      { headers }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setProducts(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);

  //shopping list
  useEffect(() => {
    const token = getToken()
    let newBody = {
      device_id: params.device_id,
    };
    console.log(newBody);
    fetch(`${configData.SERVER_URL}/Shopping-List/Images`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setShopingList(data);
        console.log(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);

  //get serach terms
  useEffect(() => {
    const token = getToken()
    let newBody = {
      device_id: params.device_id,
    };
    console.log(newBody);
    fetch(`${configData.SERVER_URL}/Search-Terms-list`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setTermsSearched(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);

  //QR
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(`${configData.SERVER_URL}/Qr-Text-List/${params.device_id}`, {
      headers,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setQrTextInputs(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);

  //appBar functions
  const [deviceConfig, setDeviceConfig] = useState(null);
  const [configLoading, setConfigLoading] = useState(false);
  const [configStatus, setConfigStatus] = useState("N/A");
  const [selectedConfig, setSelctedConfig] = useState({
    label: "retailer-tiv_taam-branch-19",
    value: "device_config",
  });
  const handleSelectedConfig = (e) => {
    setSelctedConfig(e.target.value);
  };
  const updateDeviceConfigPreset = (device_id) => {
    setConfigLoading(true);
    setDeviceConfig(null);
    setConfigStatus("N/A");
    const token = getToken()
    let newBody = {
      config_type: selectedConfig,
      config_id: "retailer-tiv_taam-branch-19",
    };
    fetch(`${configData.SERVER_URL}/DeviceConfig/${device_id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.res === "Success") {
          setDeviceConfig(data);
          setConfigLoading(false);
        } else {
          console.log(data.res);
          setConfigStatus(data.res);
          setConfigLoading(false);
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const [notifications, setNotifications] = useState([]);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  //new RT
  const getDeviceConfig = (device_id) => {
    setConfigLoading(true);
    setDeviceConfig(null);
    setConfigStatus("N/A");
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(`${configData.SERVER_URL}/DeviceConfig/${device_id}`, {
      headers,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.res === "Success") {
          setConfigStatus(data.res);
          setConfigLoading(false);
        } else {
          console.log(data.res);
          setConfigStatus(data.res);
          setConfigLoading(false);
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  //stream
  // useEffect(() => {
  //   const token = getToken()

  //   const headers = {
  //     "Content-Type": "application/json",
  //     "x-access-token": token,
  //   };
  //   const sse = new ReconnectingEventSource(
  //     `${configData.SERVER_URL}/stream/${params.serial_number
  //     }?token=${encodeURIComponent(token)}`,
  //     { headers }
  //   );
  //   console.log("this is sse", sse);

  //   const handleStream = (data) => {
  //     const a = JSON.parse(data.data);
  //     notify(a.message, "success");
  //     setNotifications((prevstate) => [...prevstate, a]);
  //     if (a.message === "Config result arrived") {
  //       setDeviceConfig(a.config);
  //     }
  //   };
  //   sse.onopen = (e) => {
  //     console.log("connection opened");
  //   };

  //   sse.onmessage = (e) => {
  //     handleStream(e);
  //     console.log("got message: ", e);
  //   };

  //   sse.onerror = (e) => {
  //     console.log("got error:", e);
  //     sse.close();
  //     setTimeout(() => {
  //       console.log("reconnecting...");
  //       sse._start();
  //     }, 5000);
  //   };
  //   sse.onclose = (e) => {
  //     console.log("connection closed, attempting to reconnect...");
  //     sse.open();
  //   };
  //   window.addEventListener("beforeunload", () => {
  //     sse.close();
  //     console.log("closing sse before page is unloaded");
  //   });

  //   return () => {
  //     sse.close();
  //     console.log("return sse close");
  //   };
  // }, []);

  //Radio Select Triggers
  const [radioSelect, setRadioSelect] = useState("product");
  const [fromRadio, setFromRadio] = useState("product");
  const [toRadio, setToRadio] = useState("product");
  const handleRadioSelectChange = (event) => {
    setRadioSelect(event.target.value);
  };
  const handleFromRadioChange = (event) => {
    setFromRadio(event.target.value);
  };
  const handleToRadioChange = (event) => {
    setToRadio(event.target.value);
  };
  //Product Trigger
  const [triggerProduct, setTriggerProduct] = useState(10943);
  const [disableTriggerClick, setDisableTriggerClick] = useState(false);
  const handleTriggerProduct = (selectedOption) => {
    console.log(selectedOption);
    setTriggerProduct(selectedOption);
  };
  const postTriggerProduct = (device_id) => {
    setDisableTriggerClick(true);
    const token = getToken()
    let newBody = {
      device_ids: [device_id],
      message: "Trigger add item",
      product_id: triggerProduct.value,
      multi: false,
    };

    fetch(
      `${configData.SERVER_URL}/Products/${params.retailer}/${params.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(newBody),
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });

    setTimeout(() => {
      setDisableTriggerClick(false);
    }, 5000);
  };
  //Campaign Trigger
  const [triggerCampaign, setTriggerCampaign] = useState(45);
  const handleTriggerCampaign = (selectedOption) => {
    setTriggerCampaign(selectedOption);
  };
  const postTriggerCampaign = (device_id) => {
    setDisableTriggerClick(true);
    const token = getToken()
    let newBody = {
      device_ids: [device_id],
      campaign_id: triggerCampaign.value,
      retailer: params.retailer,
      store: params.store,
      multi: false,
    };
    fetch(
      `${configData.SERVER_URL}/Campaigns/${params.retailer}/${params.store}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(newBody),
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
    setTimeout(() => {
      setDisableTriggerClick(false);
    }, 5000);
  };
  //Micromoment trigger
  const [triggerMicroMoment, setTriggerMicromoment] = useState(3482);
  const handleTriggerMicromoment = (selectedOption) => {
    console.log(selectedOption);
    setTriggerMicromoment(selectedOption);
  };
  const postTriggerMicromoment = (device_id) => {
    setDisableTriggerClick(true);
    const token = getToken()
    let newBody = {
      device_ids: [device_id],
      micromomment_id: triggerMicroMoment.value,
      retailer: params.retailer,
      store: params.store,
      multi: false,
    };
    fetch(`${configData.SERVER_URL}/Campaigns/Trigger/Micro`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
    setTimeout(() => {
      setDisableTriggerClick(false);
    }, 5000);
  };
  //replace functions
  const [replaceFromProduct, setReplaceFromProduct] = useState(10943);
  const [replaceFromCampaign, setReplaceFromCampaign] = useState(3482);
  const [replaceFromQr, setReplaceFromQr] = useState("none");
  const [replaceToProduct, setReplaceToProduct] = useState(10943);
  const [replaceToCampaign, setReplaceToCampaign] = useState(3482);
  const [disableReplaceClick, setDisableReplaceClick] = useState(false);

  const handleReplaceFromProduct = (selectedOption) => {
    console.log(selectedOption);
    setReplaceFromProduct(selectedOption);
  };
  const handleReplaceFromCampaign = (selectedOption) => {
    console.log(selectedOption);
    setReplaceFromCampaign(selectedOption);
  };
  const handleReplaceFromQr = (selectedOption) => {
    console.log(selectedOption);
    setReplaceFromQr(selectedOption);
  };
  const handleReplaceToProduct = (selectedOption) => {
    console.log(selectedOption);
    setReplaceToProduct(selectedOption);
  };
  const handleReplaceToCampaign = (selectedOption) => {
    console.log(selectedOption);
    setReplaceToCampaign(selectedOption);
  };

  const triggerReplaceItem = (device_id) => {
    setDisableReplaceClick(true);
    var fromValue, fromType, toValue, toType;
    if (fromRadio === "product") {
      fromValue = replaceFromProduct.value;
      fromType = "product";
    } else {
      if (fromRadio === "campaign") {
        fromValue = replaceFromCampaign.value;
        fromType = "campaign";
      } else {
        let x = String(replaceFromQr.value);
        fromValue = x.trim().replace(" ", "_");
        fromType = "text";
      }
    }
    if (toRadio === "product") {
      toValue = replaceToProduct.value;
      toType = "product";
    } else {
      toValue = replaceToCampaign.value;
      toType = "campaign";
    }
    const token = getToken()
    let newBody = {
      device_id: device_id,
      from_type: fromType,
      from_value: fromValue,
      to_type: toType,
      to_value: toValue,
      multi: false,
    };
    fetch(
      `${configData.SERVER_URL}/Products/${params.retailer}/${params.store}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(newBody),
      }
    )
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
    setTimeout(() => {
      setDisableReplaceClick(false);
    }, 5000);
  };

  return (
    <div className="container-fluid">
      {cartData && (
        <ResponsiveAppBar
          serial_number={cartData.serial_number}
          selectedConfig={selectedConfig}
          handleSelectedConfig={handleSelectedConfig}
          device_id={cartData.device_id}
          updateDeviceConfigPreset={updateDeviceConfigPreset}
          notifications={notifications}
          cartData={cartData}
        />
      )}
      {/* begginig of the table */}
      {cartData ? (
        <Paper>
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "100vh" }}
            size="small"
          >
            <Table
              sx={{ minWidth: 650 }}
              size="medium"
              aria-label="a dense table"
            >
              <TableHead></TableHead>
              <TableBody id="table-row">
                <TableRow>
                  <TableCell align="center">
                    <ListItemText
                      primary="Serial number"
                      secondary={cartData.serial_number}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <ListItemText
                      primary="device id"
                      secondary={cartData.device_id}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <ListItemText
                      primary="SDK session ID"
                      secondary={cartData.sdkSetupId}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">
                    <ListItemText
                      primary="battery"
                      secondary={cartData.battery}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <ListItemText primary="wifi" secondary={cartData.wifi} />
                  </TableCell>

                  <TableCell align="center">
                    <ListItemText
                      primary="MDM location"
                      secondary={cartData.last_location}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ) : (
        <div style={{ textAlign: "center", width: "100vw", height: "50vh" }}>
          <br />
          <br />
          <br />
          <br />
          <CircularProgress size={72} />
        </div>
      )}
      <>
        <div style={{ backgroundColor: "#0d6efd", height: "10px" }}></div>
        {cartData && shopingList && termsSearched && qrTextInputs ? (
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <strong>Screenshot</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Shopping List</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Searched</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>QR List</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Config</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <ScreenShot device_id={cartData.device_id} />
                  </TableCell>
                  <TableCell align="center">
                    <ShoppingList shoppingList={shopingList} />
                  </TableCell>
                  <TableCell align="center">
                    <Searched searched={termsSearched} />
                  </TableCell>
                  <TableCell align="center">
                    <QrList qrList={qrTextInputs} />
                  </TableCell>
                  <TableCell align="center">
                    <GetConfig
                      device_id={cartData.device_id}
                      deviceConfig={deviceConfig}
                      configLoading={configLoading}
                      configStatus={configStatus}
                      getDeviceConfig={getDeviceConfig}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <div style={{ textAlign: "center", height: "50vh" }}>
            <br />
            <br />
            <br />
            <br />
            <CircularProgress size={72} />
          </div>
        )}
      </>
      <div style={{ backgroundColor: "#0d6efd", height: "10px" }}></div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="row mb-3">
              <div className="col-md-4">
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    <strong>Select Trigger:</strong>
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={radioSelect}
                    onChange={handleRadioSelectChange}
                  >
                    <FormControlLabel
                      value="product"
                      control={<Radio />}
                      label="Product"
                    />
                    <FormControlLabel
                      value="campaign"
                      control={<Radio />}
                      label="Campaign"
                    />
                    <FormControlLabel
                      value="Trigger micro moment"
                      control={<Radio />}
                      label="Micro moment"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {products && microMoment && campaigns ? (
                <div className="col-md-5 mt-4">
                  {radioSelect === "product" ? (
                    <Select
                      placeholder="Products"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleTriggerProduct}
                      options={products}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: triggerProduct.label }}
                    />
                  ) : radioSelect === "campaign" ? (
                    <Select
                      placeholder="Campaigns"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleTriggerCampaign}
                      options={campaigns}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: triggerCampaign.label }}
                    />
                  ) : (
                    <Select
                      placeholder="Micromoments"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleTriggerMicromoment}
                      options={microMoment}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: triggerMicroMoment.label }}
                    />
                  )}
                </div>
              ) : (
                <CircularProgress size={72} />
              )}
              <div className="col-md-3 mt-4" style={{ textAlign: "center" }}>
                {radioSelect === "product" ? (
                  <Button
                    disabled={disableTriggerClick}
                    variant="outlined"
                    onClick={() => postTriggerProduct(cartData.device_id)}
                  >
                    Trigger
                  </Button>
                ) : radioSelect === "campaign" ? (
                  <Button
                    disabled={disableTriggerClick}
                    variant="outlined"
                    onClick={() => postTriggerCampaign(cartData.device_id)}
                  >
                    Trigger
                  </Button>
                ) : (
                  <Button
                    disabled={disableTriggerClick}
                    variant="outlined"
                    onClick={() => postTriggerMicromoment(cartData.device_id)}
                  >
                    Trigger
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: "#0d6efd", height: "10px" }}></div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="row mb-5">
              <div className="col-md-1 mt-1">
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    <strong>Change From:</strong>
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={fromRadio}
                    onChange={handleFromRadioChange}
                  >
                    <FormControlLabel
                      value="product"
                      control={<Radio />}
                      label="Product"
                    />
                    <FormControlLabel
                      value="campaign"
                      control={<Radio />}
                      label="Campaign"
                    />
                    <FormControlLabel
                      value="qr_text"
                      control={<Radio />}
                      label="QR text"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {products && qrTextInputs && campaigns ? (
                <div className="col-md-4 mt-4">
                  {fromRadio === "product" ? (
                    <Select
                      placeholder="Products"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleReplaceFromProduct}
                      options={products}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: replaceFromProduct.label }}
                    />
                  ) : fromRadio === "campaign" ? (
                    <Select
                      placeholder="Campaigns"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleReplaceFromCampaign}
                      options={campaigns}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: replaceFromCampaign.label }}
                    />
                  ) : (
                    <Select
                      placeholder="QR text"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleReplaceFromQr}
                      options={qrTextInputs}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: replaceFromQr.label }}
                    />
                  )}
                </div>
              ) : (
                <CircularProgress size={72} />
              )}
              <div className="col-md-1 mt-1">
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">
                    <strong>Change To:</strong>
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={toRadio}
                    onChange={handleToRadioChange}
                  >
                    <FormControlLabel
                      value="product"
                      control={<Radio />}
                      label="Product"
                    />
                    <FormControlLabel
                      value="campaign"
                      control={<Radio />}
                      label="Campaign"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {products && cartData && campaigns ? (
                <div className="col-md-4 mt-4">
                  {toRadio === "product" ? (
                    <Select
                      placeholder="Products"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleReplaceToProduct}
                      options={products}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: replaceToProduct.label }}
                    />
                  ) : (
                    <Select
                      placeholder="Campaigns"
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          height: "60px",
                          marginLeft: "10px",
                        }),
                      }}
                      onChange={handleReplaceToCampaign}
                      options={campaigns}
                      filterOption={customFilter}
                      components={{
                        MenuList: CustomMenuList,
                      }}
                      value={{ label: replaceToCampaign.label }}
                    />
                  )}
                </div>
              ) : (
                <CircularProgress size={72} />
              )}
              <div className="col-md-2 mt-4" style={{ textAlign: "center" }}>
                <Button
                  disabled={disableReplaceClick}
                  variant="outlined"
                  onClick={() => triggerReplaceItem(cartData.device_id)}
                >
                  Trigger
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleCart;
